/**
 * @fileoverview POST handler for the "/apps/:app_group_id/custom_attributes_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdCustomAttributesSettingsCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdCustomAttributesSettingsProps,
  AppsAppGroupIdCustomAttributesSettingsResult,
} from "./types";

export const postAppsAppGroupIdCustomAttributesSettings = reactQueryMutationAdapter(
  appsAppGroupIdCustomAttributesSettingsCacheKeys,
  (
    props: PostAppsAppGroupIdCustomAttributesSettingsProps
  ): Promise<AppsAppGroupIdCustomAttributesSettingsResult> => {
    const { appGroupId, ...request } = props;
    return fetch(`/apps/${appGroupId}/custom_attributes_settings`, "POST", request);
  }
);
